import _ from "underscore";

import { CanvasHandler } from "../../handlers";
import { FabricObject } from "../../types/FabricCustomType";
import { IObjectSelector } from "../../types/HandlerObjectType";

class PolygonZone implements IObjectSelector {
  private canvasHandler: CanvasHandler;
  private targetSeat!: FabricObject | null;

  constructor(canvasHandler: CanvasHandler) {
    this.canvasHandler = canvasHandler;
  }

  deactivateObjectHover() {
    throw new Error("Method not implemented.");
  }
  handleObjectLockUpdate(valueHub: any) {
    throw new Error("Method not implemented.");
  }

  public activateObjectHover(event: any): any {
  }

  public async handleSelectObject(event: any) {
    const { target } = event;
    const shape = target.item(0);
    const text = target.item(1);
    shape.set({ visible: false });
    text.set({ visible: false });
    this.canvasHandler.activeZoneSelector = target;
    this.canvasHandler.zoomHandler.zoomToCenterWithObject(target);
  }

  public async onChangeHub(valueHub: any): Promise<any> {
  }
}

export default PolygonZone;
